export default __webpack_public_path__ + "static/media/laundry2-afterB-2048w.be83e9cd.png";